module.exports = __webpack_public_path__ + "static/img/back_icon_3.5f76290.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/back_icon_3.png
// module id = Qgbm
// module chunks = 1